// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"1cb19cc1","453":"233346f9","835":"a643e583"}[chunkId] + ".chunk.js";
};